<template>
  <div class="card-header--form">
    <el-date-picker style="width: 180px"
      v-model="config.daterange"
      type="monthrange"
      range-separator="-"
      unlink-panels
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :clearable="false"
      @change="fetch">
    </el-date-picker>
    <span v-if="userPermission.LEVEL_ONE_SUPERVISE || userPermission.OPERATE"
      class="form-label">机构：</span>
    <supervise-all-select v-if="userPermission.OPERATE"
      class="form--fix-style"
      v-model="config.regulatorId"
      :option="{}"
      :callback="fetch" />
    <supervise-second-select v-if="userPermission.LEVEL_ONE_SUPERVISE"
      class="form--fix-style"
      showAll
      immediate
      v-model="config.regulatorBId"
      :option="{regulatorId: userInfo.orgId}"
      :callback="fetch" />
    <span v-if="userPermission.SUPERVISE || userPermission.OPERATE"
      class="form-label">企业：</span>
    <assign-ent-select v-if="userPermission.SUPERVISE || userPermission.OPERATE"
      class="form--fix-style"
      style="vertical-align: middle;"
      showAll
      immediate
      v-model="config.vendorId"
      :option="{}"
      :callback="fetch" />
    <span class="form-label">行业：</span>
    <cateory-all-select class="form--fix-style"
      v-model="config.categoryIds"
      :option="cateoryOptions"
      :callback="fetch" />
    <!-- <vendor-category-select v-if="userPermission.ENT"
      class="form--fix-style"
      showAll
      immediate
      v-model="config.categoryId"
      :callback="fetch"
      :option="{vendorId: userInfo.orgId }" />
    <supervise-cate-select v-if="userPermission.SUPERVISE"
      class="form--fix-style"
      showAll
      immediate
      v-model="config.categoryId"
      :callback="fetch"
      :option="{}" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// import VendorCategorySelect from '@/components/business/vendor-category-select.vue'
// import SuperviseCateSelect from '@/components/business/supervise-cate-select.vue'
import SuperviseSecondSelect from '@/components/business/supervise-second-select.vue'
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
import SuperviseAllSelect from '@/components/business/supervise-all-select.vue'
import CateoryAllSelect from '@/components/business/cateory-all-select.vue'
export default {
  name: 'product-form',
  components: { AssignEntSelect, SuperviseSecondSelect, SuperviseAllSelect, CateoryAllSelect },
  props: {
    callBack: Function
  },
  data () {
    const end = new Date()
    const start = new Date()
    start.setMonth(start.getMonth() - 6)
    return {
      config: {
        daterange: [start, end],
        categoryId: [],
        categoryIds: [],
        vendorId: null,
        regulatorId: [],
        regulatorBId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    }),
    cateoryOptions () {
      let key = this.userPermission.ENT ? 'vendorId' : (this.userPermission.LEVEL_ONE_SUPERVISE ? 'regulatorAId' : (this.userPermission.LEVEL_TWO_SUPERVISE ? 'regulatorBId' : null))
      return key ? { [key]: this.userInfo.orgId } : {}
    }
  },
  methods: {
    formatPost () {
      let { categoryIds, daterange, vendorId, regulatorBId, regulatorId } = this.config
      let _categoryIds_ = []
      categoryIds.forEach(i => {
        _categoryIds_.push(i[2])
      })
      if (this.userPermission.OPERATE) {
        console.log(regulatorId)
        return {
          categoryIds: _categoryIds_.length === 0 ? null : _categoryIds_,
          beginMonth: moment(daterange[0]).format('YYYYMM'),
          endMonth: moment(daterange[1]).format('YYYYMM'),
          vendorId,
          regulatorAId: regulatorId[0] || null,
          regulatorBId: regulatorId[1] || null
        }
      }
      return {
        categoryIds: _categoryIds_.length === 0 ? null : _categoryIds_,
        beginMonth: moment(daterange[0]).format('YYYYMM'),
        endMonth: moment(daterange[1]).format('YYYYMM'),
        vendorId,
        regulatorBId
      }
    },
    fetch () {
      this.callBack(this.formatPost())
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
<style lang="stylus" scoped>
.form-label {
  line-height: 32px;
  font-size: 14px;
  margin-left: 5px;
}

.form--fix-style {
  width: 140px;
}
</style>
